import { Component, OnInit } from '@angular/core';
import { StatusService } from '../Services/status.service';
import { AuthService } from '../Services/auth.service';
import { Logininfo } from '../classes/Loginifo';

@Component({
  selector: 'app-personal-status',
  templateUrl: './personal-status.component.html',
  styleUrls: ['./personal-status.component.css']
})
export class PersonalStatusComponent implements OnInit {
  result;
  logininfo: Logininfo = this.auth.loginID;

  constructor(
    private statusService: StatusService,
    public auth: AuthService
  ) { }

  ngOnInit() {
    this.getPersonalStatus();
  }

  getPersonalStatus() {
    var user = this.logininfo.user_code;
    var year = new Date().getFullYear();
    var month = new Date().getMonth() + 1;
    var week = 0;

    this.statusService.getPersonalStatus(user, year, month, week).subscribe(res => {
      if (res != undefined) {
        this.result = res;
      }
    });
  }
}
